import { render, staticRenderFns } from "./AllCopyrightAmendmentSubmissions.vue?vue&type=template&id=5b3f6b8a&scoped=true&"
import script from "./AllCopyrightAmendmentSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllCopyrightAmendmentSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllCopyrightAmendmentSubmissions.vue?vue&type=style&index=0&id=5b3f6b8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3f6b8a",
  null
  
)

export default component.exports